import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue';
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: {
      isLogin: true
    },
    children: [
      {
        path: '/home/main',
        name: 'main',
        component: () => import('../views/main.vue'),
        meta: {
          isLogin: false
        },
      },
     ]
  },
 {
    path: '/',
    redirect: '/home/main'
  }
]

const router = new VueRouter({
  routes
})

export default router
